module.exports = __webpack_public_path__ + "static/media/SARS_COV_2-GSE147507_2.983c79f1.csv";